<template>
  <FloatingPillButton
    variant="primary"
    @click="handleClick"
    class="absolute top-4 z-20 edit-in-canva-widget"
    :disabled="isLoading"
  >
    <template #start>
      <CanvaIcon v-if="!isLoading" />
      <CircularLoader v-else />
    </template>
    <template #center>
      {{ I18n.t("editor.edit_in_canva") }}
    </template>
  </FloatingPillButton>
</template>

<script setup lang="ts">
import { FloatingPillButton, CanvaIcon, CircularLoader } from "prism";
import { inject, toRef } from "vue";
import { Image } from "@/modules/internal_api/image";
import { PersistentStore } from "@/stores/persistent_store";
import { Stage } from "konva/lib/Stage";
import { CanvaVariant, CanvaCTAIdentifier } from "@/composables/canva_link_builder";
import { useCanvaRedirect } from "@/composables/canva_redirect";
import { I18n as I18nType } from "i18n-js";

export interface EditInCanvaWidgetProps {
  image: Image;
  persistentStore: PersistentStore;
  refreshAllHdLayers: (image: Image) => Promise<void>;
  stage: any; // Stage ref component with getStage() method
  stageHd: () => Promise<Stage>;
  getDataURL: (image: Image, stage: any, element?: any) => string;
}

const props = defineProps<EditInCanvaWidgetProps>();

const I18n: I18nType = inject("I18n");

const { isLoading, redirectToCanva } = useCanvaRedirect({
  image: toRef(props, "image"),
  persistentStore: props.persistentStore,
  refreshAllHdLayers: props.refreshAllHdLayers,
  stage: toRef(props, "stage"),
  stageHd: props.stageHd,
  getDataURL: props.getDataURL,
  canvaVariant: CanvaVariant.INLINE_EDITOR_DEFAULT,
  canvaCtaIdentifier: CanvaCTAIdentifier.WIDGET,
});

const handleClick = () => {
  redirectToCanva();
};
</script>

<style scoped>
.edit-in-canva-widget {
  left: 50%;
  transform: translateX(-50%);
}
</style>
